const navData = [
  {
    id: 0,
    name: '部门机构',
    href: '/department',
    child: [
      { id: 0, title: '部门概况', href: '/department' },
      { id: 1, title: '部门领导', href: '/department' },
      { id: 2, title: '组织机构', href: '/department' },
    ],
  },
  {
    id: 10,
    name: '新闻报道',
    href: '/report',
    child: [
      { id: 0, title: '国际新闻', href: '/report' },
      { id: 1, title: '国内新闻', href: '/report' },
      { id: 2, title: '学校新闻', href: '/report' },
      { id: 3, title: '部门新闻', href: '/report' },
    ],
  },
  {
    id: 1,
    name: '政策文件',
    href: '/document',
    child: [
      { id: 0, title: '国务院', href: '/document' },
      { id: 1, title: '教育部', href: '/document' },
      { id: 2, title: '教育厅', href: '/document' },
      { id: 3, title: '市教育局', href: '/document' },
      { id: 4, title: '学校', href: '/document' },
      { id: 5, title: '部门', href: '/document' },
    ],
  },
  {
    id: 2,
    name: '体育教学',
    href: '/teaching',
    child: [
      { id: 0, title: '教学信息', href: '/teaching' },
      { id: 1, title: '教师信息', href: '/teaching' },
      //   { id: 2, title: '教学计划', href: '/teaching' },
      //   { id: 3, title: '成绩评定', href: '/teaching' },
      //   { id: 4, title: '督导评价', href: '/teaching' },
      { id: 2, title: '教学教材', href: '/video' },
      { id: 3, title: '教学视频', href: '/video' },
      //   { id: 7, title: '教学研究', href: '/teaching' },
      //   { id: 8, title: '教学统计', href: '/teaching' },
      //   { id: 9, title: '教学评价', href: '/teaching' },
    ],
  },
  {
    id: 3,
    name: '校园群体',
    href: '/group',
    child: [
      { id: 0, title: '竞赛规程', href: '/group' },
      { id: 1, title: '竞赛活动', href: '/group' },
      { id: 2, title: '社团机构', href: '/group' },
      { id: 3, title: '社团纳新', href: '/group' },
      { id: 4, title: '社团活动', href: '/group' },
      //   { id: 2, title: '竞赛排名', href: '/group' },
      //   { id: 1, title: '单项竞赛', href: '/group' },
      //   { id: 2, title: '报名系统', href: '/group' },
      //   { id: 3, title: '学生裁判', href: '/group' },
      //   { id: 4, title: '群体统计', href: '/group' },
      //   { id: 5, title: '群体评价', href: '/group' },
    ],
  },
  {
    id: 4,
    name: '运动竞训',
    href: '/competition',
    child: [
      { id: 0, title: '队伍风采', href: '/competition' },
      // { id: 1, title: '竞赛计划', href: '/competition' },
      //   { id: 2, title: '竞赛成绩', href: '/competition' },
      { id: 1, title: '赛事新闻', href: '/competition' },
      //   { id: 4, title: '绩效评价', href: '/competition' },
    ],
  },
  //   {
  //     id: 5,
  //     name: '体质健康',
  //     href: '/health',
  //     child: [
  //       { id: 0, title: '体质测试', href: '/health' },
  //       { id: 1, title: '体质上报', href: '/health' },
  //       { id: 2, title: '体质评价', href: '/health' },
  //       { id: 3, title: '科学锻炼', href: '/health' },
  //       { id: 4, title: '工作评价', href: '/health' },
  //     ],
  //   },
  //   {
  //     id: 6,
  //     name: '体育社团',
  //     href: '/club',
  //     child: [
  //       { id: 0, title: '社团机构', href: '/club' },
  //       //   { id: 1, title: '社团工作', href: '/club' },
  //       { id: 1, title: '社团纳新', href: '/club' },
  //       { id: 2, title: '社团活动', href: '/club' },
  //       //   { id: 3, title: '社团公告', href: '/club' },
  //       //   { id: 3, title: '社团评价', href: '/club' },
  //     ],
  //   },
  {
    id: 7,
    name: '科学研究',
    href: '/research',
    child: [
      { id: 0, title: '科研信息', href: '/research' },
      { id: 1, title: '科学研究', href: '/research' },
      { id: 2, title: '专家讲座', href: '/research' },
      { id: 3, title: '教授引领', href: '/research' },
      { id: 4, title: '科研成果', href: '/research' },
    ],
  },
  {
    id: 8,
    name: '体育场馆',
    href: '/stadium',
    child: [
      //   { id: 0, title: '场馆管理', href: '/stadium' },
      //   { id: 1, title: '场馆安排', href: '/stadium' },
      //   { id: 2, title: '场馆锻炼', href: '/stadium' },
      { id: 0, title: '场馆介绍', href: '/stadium' },
      { id: 1, title: '收费标准', href: '/stadium' },
      //   { id: 4, title: '收费系统', href: '/stadium' },
    ],
  },
  {
    id: 9,
    name: '工会工作',
    href: '/union',
    child: [
      { id: 0, title: '学校工会', href: '/union' },
      { id: 1, title: '部门工会', href: '/union' },
    ],
  },
]

export default navData
